// Section 4 — Why Others Fail. Narrative tension; no CTA. Bridges into the
// Adaptation Flow section by ending on the AdaptOS reference.
export default function WhyOthersFailSection() {
  return (
    <section className="wf-sec">
      <div className="wf-inner">
        <h2 className="wf-h2">Stop memorizing. Start mastering.</h2>

        <p className="wf-p">
          Most cert training is built for passing the test. Lectures, flashcards,
          and practice questions teach you to recognize answers &mdash; not to
          think like the role. That&rsquo;s why so many people pass the exam and
          still freeze in the interview.
        </p>

        <p className="wf-p">
          And it&rsquo;s why most learners don&rsquo;t finish. Industry data puts
          online course completion rates between 5% and 15%. For the ones who
          finish, passing the exam doesn&rsquo;t always translate into landing
          the job.
        </p>

        <p className="wf-quote">There is no average learner.</p>

        <p className="wf-p">
          Cookie-cutter instruction works for the average learner. Every learner
          struggles differently &mdash; that&rsquo;s where
          {' '}<span className="wf-brand">AdaptOS</span> comes in.
        </p>
      </div>

      <style>{`
        .wf-sec {
          position: relative; z-index: 1;
          padding: clamp(48px, 8vh, 96px) clamp(16px, 4vw, 40px);
          border-top: 1px solid rgba(0,0,0,0.05);
          border-bottom: 1px solid rgba(0,0,0,0.05);
          background:
            radial-gradient(120% 120% at 50% 0%, rgba(217,119,6,0.12) 0%, transparent 60%),
            rgba(0,0,0,0.02);
        }
        .wf-inner { max-width: 720px; margin: 0 auto; text-align: center; }
        .wf-h2 {
          font-family: 'Fraunces', serif; font-weight: 500;
          font-size: clamp(28px, 4vw, 44px); line-height: 1.1;
          letter-spacing: -0.02em; margin: 0 0 28px;
        }
        .wf-p {
          font-size: clamp(16px, 1.9vw, 19px); line-height: 1.65;
          color: rgba(17,17,16,0.72); font-weight: 300; margin: 0 0 22px;
        }
        .wf-p:last-child { margin-bottom: 0; }
        .wf-quote {
          font-family: 'Fraunces', serif; font-weight: 400; font-style: italic;
          font-size: clamp(22px, 3.2vw, 32px); line-height: 1.25;
          color: #d97706; margin: 4px 0 26px;
        }
        .wf-brand { color: #d97706; font-weight: 500; }
      `}</style>
    </section>
  );
}
